import { CampaignType } from 'utils/constants/campaign';

import useIsEditCampaign from 'utils/campaign/hooks/useIsEditCampaign';

import { useSelector } from 'store/utils';

const useIsEditAdvertising = (): boolean => {
    const isEditCampaign = useIsEditCampaign();
    const campaignType = useSelector((state) => state.createCampaign.campaignType);

    return isEditCampaign && campaignType === CampaignType.Advertising;
};

export default useIsEditAdvertising;
